import { api, ENDPOINTS } from './api';

export const widgetService = {
  async fetchData<T = unknown>(type: string, params?: Record<string, unknown>): Promise<T> {
    const { data } = await api.get<T>(ENDPOINTS.widgets.data(type), { params });
    return data;
  },

  async catalog<T = unknown>(): Promise<T> {
    const { data } = await api.get<T>(ENDPOINTS.widgets.catalog);
    return data;
  },
};
